import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BaseTopBar from '@ls/react-top-bar';
import { toggleDrawer } from 'state/app/actions';
import { selectIsDrawerOpen } from 'state/app/selectors';

import KebabMenu from 'components/KebabMenu';
import MainTitle from 'components/MainTitle';
import InfoSection from 'components/InfoSection';

const TopBar = props => {
  const dispatch = useDispatch();
  const drawerOpen = useSelector(selectIsDrawerOpen);
  const handleToggleDrawer = React.useCallback(() => {
    dispatch(toggleDrawer());
  }, []); 
  return (
    <BaseTopBar
      onMenuButtonClick={handleToggleDrawer}
      menuButtonActive={drawerOpen}
      mainTitleComponent={<MainTitle />}
      infoSection={<InfoSection />}
      rightSideComponent={<KebabMenu />}
      appName={'Trade History'}
    />
  );
};

export default memo(TopBar);
